const ResumeSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_27238_23770)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.45812 3.33984C3.09549 3.33984 3.61218 3.8082 3.61218 4.38595V7.56048V10.0097V16.2937C3.61218 16.8715 3.09549 17.3398 2.45812 17.3398H2.12867C1.4913 17.3398 0.974609 16.8715 0.974609 16.2937V4.38595C0.974609 3.8082 1.4913 3.33984 2.12867 3.33984H2.45812ZM5.66724 4.97223C5.66724 3.51764 6.69053 2.92453 7.95271 3.64853L17.3349 9.02909C18.5976 9.75318 18.5976 10.9266 17.3349 11.6509L7.95271 17.0315C6.69053 17.7548 5.66724 17.1625 5.66724 15.7064V4.97223Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_27238_23770">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="translate(0.128418 0.839844)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ResumeSvg;
